import React, { Component } from 'react';
import HomeComponent from './components/Home/Home';
import NavbarComponent from './components/Navbar/Navbar';
import LoginComponent from './components/Login/Login';
import { connect } from 'react-redux';
import { setUserId, setUser, setToken, userLogin } from './redux/modules/auth';
import { getFromStorage } from './utils/storage';
import apiUrl from './utils/apiUrl';
import AppSpinner from './components/AppSpinner/AppSpinner';
import './App.scss';

function mapDispatchToProps(dispatch) {
  return {
    userLogin: () => dispatch(userLogin()),
    setUser: user => dispatch(setUser(user)),
    setUserId: userId => dispatch(setUserId(userId)),
    setToken: token => dispatch(setToken(token))
  };
}

const select = state => {
  return {
    authenticated: state.auth.authenticated,
    user: state.auth.user,
    userId: state.auth.userId,
    token: state.auth.token
  };
};

class ConnectedApp extends Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: true
    };
  }

  async componentDidMount() {
    const localStorageToken = getFromStorage('nibi_admin_app');

    if (localStorageToken && localStorageToken.token) {

      const { token } = localStorageToken;

      // Verify token
      const prom = await fetch(`${apiUrl}/signin/token/admin/verify?token=${token}`);
      const json = await prom.json();

      if (json.success) {

        const { userId } = json;

        this.props.setToken({ token });
        this.props.userLogin();
        this.props.setUserId({ userId });

        const dataUser = await fetch(`${apiUrl}/users/user/${userId}`);
        const res = await dataUser.json();
        this.props.setUser({ user: res });
      }
    }

    this.setState({ loading: false });
  }

  render() {

    const { loading } = this.state;
    const { authenticated } = this.props;

    return (
      <div className="App">
        <NavbarComponent />
        {
          loading ? <div className="app-loader"><AppSpinner /></div> :
            !authenticated ? <LoginComponent /> : <HomeComponent />
        }

      </div>
    );
  }

}

const App = connect(select, mapDispatchToProps)(ConnectedApp);

export default App;
